<!-- <div class="container-fluid py-4">
  <div class="row mb-4">
    <div class="col-md-4" *ngFor="let card of resumenCards; index as i">
      <div class="card card-stats">
        <div class="card-body">
          <div class="row">
            <div class="col-5">
              <div
                class="icon-big text-center text-white rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4 class="card-title mb-0">{{ card.value }}</h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small class="desc">{{ card.desc }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
 -->
<div class="container-fluid py-4">
  <div class="row mb-4">
    <div
      [class]="i < 2 ? 'col-md-6' : 'col-md-4'"
      *ngFor="let card of resumenCards; index as i"
    >
      <div
        class="card card-stats"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <!-- [routerLink]="i === 0 ? ['/logistics/fees/courier'] : null"
        [style.cursor]="i === 0 ? 'pointer' : 'default'" -->
        <div class="card-body">
          <div class="row">
            <div class="col-5">
              <div
                class="icon-big text-center text-white rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4 class="card-title mb-0">{{ card.value }}</h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small class="desc">{{ card.desc }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
